import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    message,
    Form,
    Input,
    Select, notification
} from 'antd';
import { apiGet, apiPut, parseJsonResponse } from "../api/apiClient";
import { getInitialValuesFormular, updateDataContent } from "../utils/formUtils";
import { SaveIcon } from "../components/ui/SaveIcon";
import { ArrowLeftOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { AutoComplete } from 'antd';
import '../Styles/Kontakte.css'
import { useSwitch } from '../pages/SwitchContext';
import { Link } from "react-router-dom";

const { Option } = Select;

const KontaktDetails = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true);
    const [saveIcon, setSaveIcon] = useState(false);
    const [saveIcon1, setSaveIcon1] = useState(false);
    const dataContentRef = useRef(null);
    const [enumerationValuesContent, setEnumerationValuesContent] = useState(null);
    const { kontaktID, auftragID } = useParams(); // Get the activeKey from the URL
    const [formFormular] = Form.useForm();
    const [selectedOption, setSelectedOption] = useState(null);
    const [highlightedFields, setHighlightedFields] = useState([]);
    const { isSwitchOn, toggleSwitch } = useSwitch();

    const handleSelectChange = (value) => {

        setSelectedOption(value);
    };

    const fetchKontakt = async () => {
        setIsLoading(true);
        dataContentRef.current = null;
        try {
            const [kontaktRes, enumRes] = await Promise.all([
                apiGet(`/helper/acl/kontakte/${kontaktID}?populate=deep`),
                apiGet('/kontakte/enumvalues'),
            ]);
            dataContentRef.current = await parseJsonResponse(kontaktRes);
            setEnumerationValuesContent(await parseJsonResponse(enumRes));
        } catch (error) {
            message.error("Error while fetching profiles!");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchKontakt().then();

    }, []);


    const handleBackButtonClick = (auftragID) => {
        formFormular.validateFields(['KontakttypV', 'Kontaktname'])
            .then((values) => {

                // Both fields are filled, log the values and navigate to the /kontakte URL
                if (values.KontakttypV === undefined || values.Kontaktname === undefined || values.Kontaktname === '') {
                    // Initialize highlightedFields array
                    const newHighlightedFields = [];

                    // Check and add Kontakttyp to highlightedFields if its value is undefined
                    if (values.KontakttypV === undefined) {
                        newHighlightedFields.push('KontakttypV');
                    }

                    // Check and add Kontaktname to highlightedFields if its value is undefined
                    if (values.Kontaktname === undefined || values.Kontaktname === '') {
                        newHighlightedFields.push('Kontaktname');
                    }

                    // Set the new highlightedFields
                    setHighlightedFields(newHighlightedFields);

                    notification.error({
                        message: 'Validation Error',
                        description: 'Bitte Pflichtfelder ausfüllen.',
                    });
                } else {
                    if(auftragID > 0) {
                        // Both fields are filled, navigate back to Auftrag
                        navigate("/auftrag/"+auftragID+"#kontaktliste");
                    } else {
                        // Both fields are filled, navigate to the /kontakte URL
                        navigate("/kontakte");
                    }
                }
            }).catch((errorInfo) => {
                console.log(errorInfo);
            });
    };

    return (
        <div style={{ padding: '20px' }} className={`lg:w-[84%] w-[90%] ml-auto mr-[2%] rounded-[30px]  ${isSwitchOn ? 'bg-black' : 'bg-white'}`}>
            <h2 className={`font-bold mb-[20px] text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Kontakt bearbeiten</h2>
            {saveIcon1 && <SaveIcon saveIcon={saveIcon} />}
            {auftragID == null ? (
                <Link
                    type="primary"
                    onClick={handleBackButtonClick}
                    icon={<ArrowLeftOutlined />} className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  mt-[10px] p-[10px] rounded-full LinkHover`}>
                    Zurück zur Übersicht
                </Link>
                ) : (
                <Link
                        type="primary"
                        onClick={() => handleBackButtonClick(auftragID)}
                    icon={<ArrowLeftOutlined />} className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  mt-[10px] p-[10px] rounded-full LinkHover`}>
                    Zurück zum Auftrag
                </Link>
                )}
            <div className="flex  justify-center mt-[30px]">

                {dataContentRef.current && !isLoading && (
                    <Form
                        form={formFormular}
                        onBlur={(e) => {
                            const updateValue = (e.target.id === "KontakttypV" || e.target.id === "AnredeV" || e.target.id === "TitelV")
                                ? selectedOption
                                : e.target.value;

                            updateDataContent(e.target.id, updateValue, dataContentRef.current);
                            setSaveIcon(true);
                            setSaveIcon1(true);
                            apiPut(`/helper/acl/kontakte/${kontaktID}`, dataContentRef.current)
                                .then(response => {
                                    if (!response.ok) throw new Error('Failed to update data.');
                                    setTimeout(() => setSaveIcon(false), 300);
                                    setTimeout(() => setSaveIcon1(false), 3000);
                                })
                                .catch(error => console.error('Error:', error));
                        }}
                        initialValues={getInitialValuesFormular(dataContentRef.current)}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        className=" kONtAK"
                    >
                        <div className={`${isSwitchOn ? 'maxColor' : ''} max-w-[600px] inputsSection`}>
                            <Form.Item label="Kontakttyp" name="KontakttypV"
                                validateStatus={highlightedFields.includes('KontakttypV') ? 'error' : ''}
                                help={highlightedFields.includes('KontakttypV') ? 'Bitte Kontakttyp auswählen' : null}>
                                {/* <Select onChange={handleSelectChange}>
                                {enumerationValuesContent.Kontakttyp.map((option, index) => (
                                    <Option key={index} value={option}>
                                        {option}
                                    </Option>
                                ))}
                            </Select> */}
                                <AutoComplete
                                    className={"AutoCompleteTextArea"}
                                    options={enumerationValuesContent.Kontakttyp?.map((option, index) => ({ value: option, key: index }))}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleSelectChange} // Add your change handler if needed
                                >
                                    <TextArea
                                        placeholder="Kontakttyp"
                                        autoSize={true}
                                        className="textInput"
                                    />
                                </AutoComplete>
                            </Form.Item>
                            <Form.Item label="Anrede" name="AnredeV">
                                <AutoComplete
                                    className={"AutoCompleteTextArea"}
                                    options={enumerationValuesContent.Anrede?.map((option, index) => ({ value: option, key: index }))}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleSelectChange} // Add your change handler if needed
                                >
                                    <TextArea
                                        placeholder="Anrede"
                                        autoSize={true}
                                        className="textInput"
                                    />
                                </AutoComplete>
                            </Form.Item>
                            <Form.Item label="Titel" name="TitelV">
                                <AutoComplete
                                    className={"AutoCompleteTextArea"}
                                    options={enumerationValuesContent.Titel?.map((option, index) => ({ value: option, key: index }))}
                                    filterOption={(inputValue, option) =>
                                        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleSelectChange}
                                >
                                    <TextArea
                                        placeholder="Titel"
                                        autoSize={true}
                                        className="textInput"
                                    />
                                </AutoComplete>
                            </Form.Item>
                            <Form.Item label="Kontaktname" name="Kontaktname"
                                validateStatus={highlightedFields.includes('Kontaktname') ? 'error' : ''}
                                help={highlightedFields.includes('Kontaktname') ? 'Bitte Kontaktname eingeben' : null}>
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Unternehmen" name="Unternehmen">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Kontaktabteilung" name="Kontaktabteilung">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Berufsbezeichnung" name="Berufsbezeichnung">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Vornamen" name="Vornamen">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Nachname" name="Nachname">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Postleitzahl" name="Postleitzahl">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Ort" name="Ort">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Strasse" name="Strasse">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Hausnummer" name="Hausnummer">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Telefon" name="Telefon">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Fax" name="Fax">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Mail" name="Mail" rules={[
                                {
                                    type: 'email',
                                    message: 'Bitte eine gültige E-Mail-Adresse eingeben',
                                }
                            ]}>
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Weblink" name="Weblink">
                                <Input className="inputsAll" />
                            </Form.Item>
                            <Form.Item label="Mobil" name="Mobil">
                                <Input className="inputsAll" />
                            </Form.Item>
                        </div>
                        <div className={`txtSection ${isSwitchOn ? 'maxColor' : ''}`}>
                            <Form.Item label="Anmerkungen" name="Anmerkungen">
                                <TextArea className="textBorder" autoSize={true} rows={4} />
                            </Form.Item>
                        </div>

                    </Form>
                )}
            </div>
        </div>
    );
};

export default KontaktDetails;